import React, {useEffect, useState} from 'react';
import './style.scss';
import {Card, CardContent, Grid, Tooltip} from '@material-ui/core'
import {Garlic, starFill} from '../../assets/images/images'
import CardMedia from "@material-ui/core/CardMedia";
import {makeStyles} from "@material-ui/core/styles";
import {
  APP_DOMAIN_PREFIX,
  farmingDiscount,
  fruitsVegDiscount,
  fisheryDiscount,
  liveStockDiscount,
  servicesDiscount
} from '../../environment';


const useStyles = makeStyles((theme) => ({
  card: {
    // height: '100%',
    display: 'flex',
    flexDirection: 'column',
    cursor: 'pointer',
    boxShadow: 'none'
  },
  cardMedia: {
    paddingTop: '56.25%', // 16:9,
    height: 70
  },
  cardContent: {
    flexGrow: 0,
    padding: 0,
    background: 'transparent',
    marginTop:10,
    paddingBottom:10
  }
}));

function ServiceCard(props) {
  const {lg = 2, onClick, data, pageTitle = ''} = props;
  const [discount, setDiscount] = useState(0)

  useEffect(() => {
    let page = pageTitle.toLowerCase()
    const dis = page === 'crops & grains' ? farmingDiscount : page === 'fruits & vegetables' ? fruitsVegDiscount :
      page === 'fisheries & aquaculture' ? fisheryDiscount : page === 'livestock & dairy' ? liveStockDiscount :
        page === 'agri services & inputs' ? servicesDiscount : 0;
    setDiscount(dis)
  }, [pageTitle])

  if (data.imagePath !== "")
    data.img = data.imagePath || data.imgPath;
  let position = data.img?.search("userImages");
  let imageUrl = APP_DOMAIN_PREFIX + data.img;
  if (position === -1)
    imageUrl = APP_DOMAIN_PREFIX + "/userImages/" + data.img;
  const classes = useStyles()
  return (
    <Grid item className='seller-card-container' lg={lg} xs={12} sm={4} md={4} >
      <Card className={classes.card}>
        <div className='seller-img-container'>
          <CardMedia
            className={classes.cardMedia}
            // image="https://source.unsplash.com/random"
            image={(data && data.img && imageUrl) || Garlic}
            title="Image title"
          />
          {/*<img src={Garlic} alt='img' className='seller-img'/>*/}
        {data && data.discountCapture > 0 &&  <Tooltip title={'Discount'} arrow>
            <p className='discount'>{data?.discountCapture} %</p>
          </Tooltip> }
        </div>
        <CardContent className={classes.cardContent}>
          <h3 className='font-16 text-capitalize sub-heading-color pl-5'>{data && data?.agriBusinessId.agriBusinessName	 || ''}</h3>
          <p className=' available discount-color'>{data ? data[2] : ''}</p>
          <div className='display-flex align-items-center justify-content-between rate  pl-5'>

            <div className='price-container display-flex align-items-center justify-content-between full-width'>
              {data && data.discountCapture > 0 && <p className='m-0 font-14 red-color line-through'>
                {data && data.discountCapture > 0 && data.currency + data.priceSetByVendor}
              </p>}
              <p className='current sub-heading-color text-bold'>
                {data && data.discountCapture > 0 ? data.currency + (Number(data.serviceCharges) - ((Number(data.serviceCharges) * Number(data?.discountCapture)/100))) :  data.currency + data.serviceCharges}</p>
              {/*<p className='previous in-active-color line-through basic-font ml-10'></p>*/}
            </div>

          </div>
          {data && data.ratings && <div className='rating-container display-flex align-items-center pl-5 p-5 m-0'
          // style={{background:'red'}}
          >
            {/*<h6 className=' text-capitalize sub-heading-color pl-5 m-0'>{data.countryName}</h6>*/}

            {/*<UploadFile className='discount-color'/>*/}
            {/* <img src={starFill} style={{filter: 'brightness(1.4)'}} alt=''/>
            <p className='rating-value discount-color text-bold ml-5 m-0'>5.5</p> */}
          </div>}
        </CardContent>
      </Card>
    </Grid>
  );
}

export default ServiceCard;
